import { HttpClient } from '../HttpClient';
/**
 * * Get List of Lookup Departments per Company
 */
interface GetDepartmentLookupsParams {
  CompanyId: number;
  SortColumn?: string;
  SortOrder?: "asc" | "desc";
  PageNumber?: number;
  RowsPerPage?: number;
}

export const GetDepartmentLookups = async ({
  CompanyId,
  SortColumn,
  SortOrder = "asc",
  PageNumber = 1,
  RowsPerPage,
}: GetDepartmentLookupsParams) => {
  try {
    const { data } = await HttpClient.get(`/api/Lookups/Departments`, {
      params: {
        CompanyId,
        PageNumber,
        RowsPerPage,
        SortColumn,
        SortOrder,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
